// extracted by mini-css-extract-plugin
export default {"container":"jQ","productarea":"kQ","btn":"lQ","promowrapper":"mQ","upsellarea":"nQ","subtitle":"oQ","system":"pQ","desc":"qQ","cardswrap":"rQ","cards":"sQ","squareloadingcontainer":"tQ","squareloading33":"uQ"};
    if(module.hot) {
      // 1714442370817
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  